import request from '@/axios'

export function fileUpload (customer_id, payload) {
  return request({
    url:`file/upload/local/${customer_id}`,
    method:'POST',
    data:payload
  })
}
// file/upload/local/getHeader/{customer_id} 
export function ExcelHeaderApi (customer_id, payload) {
  return request({
    url:`file/upload/local/getHeader/${customer_id}`,
    method:'POST',
    data:payload
  })
}

export function getStaffDbHeaderApi (customer_id, platform_module_id) {
  return request({
    url:`field_settings/get_module_related_fields/${platform_module_id}/${customer_id}`,
    method:'GET'
  })
}
export function importExcelApi (module, customer_id, payload) {
  return request({
    
    url:`file/upload/import/${module}/${customer_id}`,
    method:'POST',
    data:payload
  })
}

export function importedBatchUpload (module, customer_id, payload) {
  return request({
    
    url:`file/upload/imported/${module}/${customer_id}`,
    method:'POST',
    data:payload
  })
}


export function leadMapApi (customer_id, payload, type) {
  return request({
    url:`file/upload/${type}/map/child/${customer_id}`,
    method:'POST',
    data:payload
  })
}

export function exportApiDownload (customer_id, type) {
  return request({
    url:`file/template/${type}/${customer_id}`,
    method:'POST',
  })
}

export function ModuleheaderApi (customer_id, type) {
  return request({
    url:`file/headers/${type}/${customer_id}`,
    method:'POST',
  })
}